<template>
    <div>
        <div class=" has-text-white borBott">
            <div class="azTab is-size-7" :class="{selected: tabView == 1}"  @click="tabSwitcher(1)">Notifications</div>
            <div class="azTab  is-size-7" :class="{selected: tabView == 2}"  @click="tabSwitcher(2)">Feed</div>
        </div>
    </div>
</template>

<script>

export default {
    mounted: function(){
        this.tabView = this.$root.app.rightBarComponent == 'notifications' ? 1 : 2
    },

    data: function() {
        return {
            tabView: 1
        }
    },

    methods: {
        tabSwitcher: function(val){

            this.tabView = val
            this.$root.app.rightBarComponent = val == 1 ? 'notifications' : 'feed'
        }
    }
}
</script>

<style scoped>
    .borBott{
        border-bottom: 1px solid #878787
    }
</style>